module.exports = __webpack_public_path__ + "static/media/1531475325087 1.899679a3.jpg";